<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>

        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">

                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="examForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="mb-3 col">
                                            <h3 class="main-content-label mb-1 ">
                                                <b>Exam Form</b>
                                            </h3>
                                        </div>
                                        <hr>
                                        <div class="row clearfix mt-3">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <div class="row">
                                                        <div class="col-sm-3">
                                                             <div class="form-group">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Exam</mat-label>
                                                            <mat-select formControlName="EmName"  placeholder="Exam"
                                                            
                                                            (selectionChange)="onExamChange($event.value)"
                                                                class="colorblack" #select1777>
                                                                <mat-select-filter *ngIf="select1777.focused" [placeholder]="'Filter'"
                                                                    [displayMember]="'EmName'" [array]="examList"
                                                                   ></mat-select-filter>
                                                                <mat-option *ngFor="let item of examList"
                                                                    [value]="item.EmId">
                                                                    {{item.EmName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field> 
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                            <div class="form-group" *ngIf="prefix != ''">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label>Registration No.</mat-label>

                                                                    <input readonly matInput value="{{ prefix + ' / ' + formattedPrn }}"
                                                                        placeholder="Registration No" maxlength="10">
                                                                </mat-form-field>
                                                            </div>
                                                            <div class="form-group" *ngIf="prefix == ''">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label>Registration No.</mat-label>

                                                                    <input readonly matInput formControlName="stuPerRgNo"
                                                                        placeholder="Registration No" maxlength="10">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label>College Name</mat-label>
                                                                    <mat-select disabled #select23 placeholder="College"
                                                                        class="colorblack" formControlName="Colg">
                                                                        <mat-select-filter *ngIf="select23.focused"
                                                                            [placeholder]="'Filter'"
                                                                            [displayMember]="'CgName'"
                                                                            [array]="collegeList"
                                                                            (filteredReturn)="filteredCollegeList =$event">
                                                                        </mat-select-filter>
                                                                        <mat-option
                                                                            *ngFor="let item of filteredCollegeList"
                                                                            [value]="item.CgCode">{{item.CgName}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label>Branch </mat-label>
                                                                    <mat-select disabled #select22 placeholder="Branch"
                                                                        class="colorblack" formControlName="Branch">
                                                                        <mat-select-filter *ngIf="select22.focused"
                                                                            [placeholder]="'Filter'"
                                                                            [displayMember]="'StrName'"
                                                                            [array]="courseStreamList"
                                                                            (filteredReturn)=" filteredStreamList =$event"></mat-select-filter>
                                                                        <mat-option
                                                                            *ngFor="let item of  filteredStreamList"
                                                                            [value]="item.StrId">
                                                                            {{item.StrName}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> Name</mat-label>
                                                                    <input readonly matInput value="{{stuName}}" 
                                                                        placeholder="" maxlength="10">
                                                                        <!-- formControlName="Name" -->
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3">
                                                            <div class="form-group">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> Category</mat-label>
                                                                    <input readonly matInput value="{{stuCast}}" 
                                                                        placeholder="" maxlength="10">
                                                                        <!-- formControlName="Cate" -->
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3 hidden">
                                                            <div class="form-group">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> Center</mat-label>
                                                                    <input readonly matInput formControlName="Center"
                                                                        placeholder="" maxlength="10">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3 hidden">
                                                            <div class="form-group">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> Valid</mat-label>
                                                                    <input readonly matInput formControlName="Valid"
                                                                        placeholder="" maxlength="10">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-3 hidden">
                                                            <div class="form-group">
                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> </mat-label>
                                                                    <input readonly matInput formControlName="Valid1"
                                                                        placeholder="" maxlength="10">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
<!-- 
                                                <div *ngIf="SubTable" class="col-sm-12">
                                                    <div>Subjects</div>
                                                    <div class="table-responsive table-container tab mt-1">

                                                        <table class="table table-bordered text-nowrap">
                                                            <thead class="thZindex">
                                                                <tr>
                                                                    <th class="hidden">

                                                                    </th>
                                                                    <th class="hidden">

                                                                    </th>
                                                                    <th class="f600">
                                                                        Type
                                                                    </th>
                                                                    <th class="f600 hidden">
                                                                        Subject
                                                                    </th>
                                                                    <th class="f600">
                                                                        Subject
                                                                    </th>
                                                                    <th class="f600 hidden">
                                                                        Pass
                                                                    </th>
                                                                    <th class="f600 tab3 hidden">
                                                                        Appr
                                                                    </th>
                                                                    <th class="f600">
                                                                        Comments
                                                                    </th>
                                                                    <th class="f600 hidden">
                                                                        NewSub
                                                                    </th>
                                                                    
                                                                </tr>
                                                            </thead>
                                                            <tbody id="table_data" formArrayName="SubArray">
                                                                <ng-container
                                                                    *ngFor="let subData of getSubArrayControls(); let i = index">
                                                                    <tr [formGroupName]="i" *ngIf="isVisible(subData)">
                                                                        <td class="hidden">
                                                                            <input readonly class="tab2"
                                                                                formControlName="EsId">
                                                                        </td>
                                                                        <td class="hidden">
                                                                            <input readonly class="tab2"
                                                                                formControlName="SrNo">
                                                                        </td>
                                                                        <td>
                                                                            <input readonly class="tab2"
                                                                                formControlName="EsType"> -->
                                                                            <!-- {{subData.EsType}} -->
                                                                        <!-- </td> -->
                                                                        <!-- <td class="hidden">
                                                                            <input readonly class="tab2"
                                                                                formControlName="Sub"> -->
                                                                            <!-- {{subData.Sub}} -->
                                                                        <!-- </td>
                                                                        <td>
                                                                            <input readonly class="tab2"
                                                                                formControlName="EsName">

                                                                        </td>
                                                                        <td class="hidden">
                                                                            <input readonly class="tab2 "
                                                                                formControlName="Pass">
                                                                        </td>
                                                                        <td class="hidden">
                                                                            <mat-select
                                                                                [disabled]="checkvalidattion(subData,i)"
                                                                                *ngIf="subData.get('showDropdown').value"
                                                                                formControlName="App">
                                                                                <mat-option value="Y">
                                                                                    Y
                                                                                </mat-option>
                                                                                <mat-option value="N">
                                                                                    N
                                                                                </mat-option>
                                                                            </mat-select>
                                                                            <mat-error class="margin_tp mrgtp"
                                                                                *ngIf="subData.get('App').hasError('mandatory') && subData.get('App').touched">
                                                                                Mandatory
                                                                            </mat-error>

                                                                        </td>
                                                                        <td>
                                                                            <p><b class="red"
                                                                                    *ngIf="isAttendanceDeficient(subData)">Attendance
                                                                                    is deficient</b></p>
                                                                        </td>
                                                                        <td class="hidden">
                                                                            <input readonly class="tab2 "
                                                                                formControlName="NewSub">
                                                                        </td>
                                                                    </tr>
                                                                </ng-container>

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                            </div> -->

                                            <div *ngIf="subjectsData" class="mb-2">
  <mat-checkbox
    [(ngModel)]="allowSubjectChange"
    [ngModelOptions]="{ standalone: true }"    
    [disabled]="SaveDisable || Failed"
    class="navy-checkbox-text"><b>
    I hereby confirm that I want to change my subject. I understand that once submitted,
    the subject change is permanent and irreversible, and I agree to abide by the
    University rules and regulations.</b>
  </mat-checkbox>
</div>
<h6 class="red">
  Note : You may change your subject only before submitting the exam form
</h6> 


                                                <div *ngIf="subjectsData" class="mt-4">

<h6 *ngIf="optData && optData.length > 0" class="mb-1 redCol">
  Please follow the rules below when making your selection:
</h6> 
                   
                    <ng-container *ngIf="getValidationErrorsKeys().length > 0; else optDataSection">
                        <div *ngFor="let errorCode of getValidationErrorsKeys()">
                            <p style="color: red;">{{ validationErrors[errorCode] }}</p>
                        </div>
                    </ng-container>

                    <ng-template #optDataSection>
                        
                        <div class="col-sm-12" *ngFor="let opt of optData">
                            <div  *ngIf="optData.length > 0">
                                <!-- <b>For OptCode = {{opt.OpCode}} : Min = {{opt.OpMin}} And Max = {{opt.OpMax}}</b> -->
                                 <p class="mb-1" *ngIf="opt.OpMin === opt.OpMax">
                                    For Option {{opt.OpCode}} Select Only {{opt.OpMin}}
                                 </p>
                                 <p class="mb-1" *ngIf="opt.OpMin != opt.OpMax">
                                    <!-- For Option {{opt.OpCode}} : You must select a minimum of {{opt.OpMin}} and a maximum of {{opt.OpMax}} option  -->
                                    For Option {{opt.OpCode}} Select minimum {{opt.OpMin}} or maximum {{opt.OpMax}} 
                                 </p>
                                 
                            </div>
                        </div>
                    </ng-template>

                    <ng-container *ngIf="getSubjectOfferDetails().length > 0">
                        <div *ngFor="let detail of getSubjectOfferDetails()">
                          <p class="ml1">{{ detail }}</p>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="subjectsData" class="mt-4">
                <!-- SUBJECTS -->
                <div *ngIf="subjectsData" class="col-sm-12">
                <div class="row">
                <div class="flex-container">
                <!-- Single Subjects -->
               <div *ngIf="Subs" class="col-sm-12">
            <div class="card-container" style="display:flex;flex-wrap:wrap;">
            <mat-card *ngFor="let subValue of getSubKeys()" class="example-card2">
              <h5>{{ subValue === ' ' ? 'Mandatory' : 'Options: ' + subValue }}</h5>
              <mat-card-content>
                <div *ngFor="let subjectItem of groupedSubjects[subValue]">
                <div *ngIf="subjectItem.EsOpCode === ' '">
                    {{ getSubjectCode(subjectItem) }} - {{ getSubjectName(subjectItem) }}
                </div>
                <mat-checkbox
                    *ngIf="subjectItem.EsOpCode !== ' '"
                    [(ngModel)]="subjectItem.checked"
                    [ngModelOptions]="{standalone:true}"
                    [disabled]="SaveDisable || !allowSubjectChange  || Failed "
                    (change)="onCheckboxChanged($event, subjectItem)">
                    {{ getSubjectCode(subjectItem) }} - {{ getSubjectName(subjectItem) }}
                </mat-checkbox>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <!-- Group Subjects -->
        <div *ngIf="OptSub">
          <div class="card-container" style="display:flex;flex-direction:row;">
            <mat-card *ngFor="let group of GroupData" class="example-card2">
              <mat-checkbox
                [(ngModel)]="group.isSelected"
                [ngModelOptions]="{standalone:true}"
                [disabled]="SaveDisable || !allowSubjectChange || Failed"
                (change)="onCheckboxChanged($event, group)">
                {{ group.EsSupCode }} - {{ group.EsName }}
              </mat-checkbox>
              <mat-card-content>
                <div style="display:flex;flex-wrap:wrap;gap:16px;">

                  <mat-card class="example-card2"
                    *ngFor="let subValue of getSubKeysForGroup(group.EsCode)">
                    
                    <h5>{{ subValue === ' ' ? 'Mandatory'
                    : 'Options: ' + subValue }}
                    </h5>
                    <mat-card-content>
                      <div *ngFor="let subjectItem of groupedSubjects2[group.EsCode][subValue]">
  <div *ngIf="subjectItem.EsOpCode === ' '">
    {{ getSubjectCode(subjectItem) }} - {{ getSubjectName(subjectItem) }}
  </div>
  <mat-checkbox
    *ngIf="subjectItem.EsOpCode !== ' '"
    [(ngModel)]="subjectItem.checked"
    [ngModelOptions]="{standalone:true}"
    [disabled]="SaveDisable"
    (change)="onCheckboxChanged($event, subjectItem)">
    {{ getSubjectCode(subjectItem) }} - 
    {{ getSubjectName(subjectItem) }}
  </mat-checkbox>
</div>
                    </mat-card-content>
                  </mat-card>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

                                            <div *ngIf="ShowMsg">
                                                <p><b class="red">{{Message}}</b></p>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <button type="button" *ngIf="Gen" [disabled]="SaveDisable" 
                                                            class="btn sz btn-primary btn-icon-text floatright mt-1 fr"
                                                            (click)="Generate()">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="20vh" src="../../assets/images/save.gif"
                                                                    style="margin-right: 5px;">
                                                                Save
                                                            </span>
                                                        </button>
                                                        <button type="button"  (click)="Print()" class="btn btn-primary fr sz btn-icon-text floatright mr-3 mt-1">
                                                            <span style="display: contents; align-items: center;">
                                                                <img width="20vh" src="../../assets/images/printer.gif"
                                                                    style="margin-right: 5px;">
                                                                Print
                                                            </span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>

